var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.ready)?_c('router-view'):_vm._e(),_c('loading',{attrs:{"active":!_vm.ready,"color":"#0061ad"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }